// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2QsN7","search":"Settings_search__3LpGb","filter":"Settings_filter__2TqXc"};